import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import Roles from 'utils/enums/Roles';

import { ListingDetail } from './ListingDetail';
import { ListingsList } from './ListingsList';

export const Bulletin = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT, Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR],
              entitlements: [Roles.JOBMARKET_ADMIN]
            }}
            user={currentUser}
          >
            <ListingsList />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT, Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR],
              entitlements: [Roles.JOBMARKET_ADMIN]
            }}
            user={currentUser}
          >
            <ListingDetail />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
